import { getGraphQLClient } from "../../../portal";
import { log as pilog } from "@limitless/common/utils";
const TRULIOO_ACCESS_TOKEN = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "generateEmbedIdAccessToken"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "publicKey"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "generateEmbedIdAccessToken"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "publicKey"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "publicKey"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "accessToken"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 164,
    "source": {
      "body": "\n    mutation generateEmbedIdAccessToken($publicKey: String!) {\n        generateEmbedIdAccessToken(publicKey: $publicKey) {\n            accessToken\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export default class TruliooClient {
  constructor(obj) {
    for (const fld in obj) {
      if (Reflect.getOwnPropertyDescriptor(obj, fld)) {
        this[fld] = obj[fld];
      }
    }
    this.embedIDURL = this.embedIDURL ? this.embedIDURL : "https://embedid.trulioo.com/embedid";
    this.publicKey = process.env.REACT_APP_DOC_KEY;
    document.addEventListener("securitypolicyviolation", error => {
      this.securityPolicyError = error;
    });
    (async () => {
      try {
        if (this.securityPolicyError) {
          throw this.securityPolicyError;
        }
        this.registerEvents();
        await this.injectAccessToken();
        this.loadEmbedID();
      } catch (error) {
        this.errorHandler(error, "Something went wrong during EmbedID form initialization");
      }
    })();
  }

  /**
   * Registers callbacks.
   */
  registerEvents() {
    const truliooClient = this;
    if (window && window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    }
    function onMessage(event) {
      const log = pilog.getLogger("TrluilooClient");
      try {
        const eventOriginCompleteURL = `${event && event.origin}/embedid`;
        // Check sender origin to be trusted
        if (truliooClient.embedIDURL !== eventOriginCompleteURL) {
          return;
        }
        const data = event.data;
        if (truliooClient[data.function]) {
          truliooClient[data.function].call(window, JSON.parse(data.message));
        } else if (data.function === "onInitialRenderComplete") {
          // You can remove this case if you use the onInitialRenderComplete parameter
        } else {
          log.info(`Tried to trigger ${data.function} but found no available callBack`);
        }
      } catch (error) {
        log.debug(error, "Something went wrong during callback registration");
      }
    }
  }

  /**
   * Generates the access token and stores it into this.accessToken variable.
   */
  async injectAccessToken() {
    try {
      if (!this.accessToken) {
        const graphQLClient = getGraphQLClient();
        const response = await graphQLClient.mutate({
          mutation: TRULIOO_ACCESS_TOKEN,
          variables: {
            publicKey: this.publicKey
          }
        }).then(response => {
          if (response.data) {
            return response.data.generateEmbedIdAccessToken;
          }
        }).catch(error => {
          this.errorHandler(error, "Something went wrong during access token generation");
          throw error;
        });
        const deconstructedResult = response;
        if (response && response.status >= 400) {
          throw new Error(deconstructedResult.error || deconstructedResult);
        }
        const accessToken = deconstructedResult.accessToken;
        this.accessToken = accessToken;
      }
    } catch (error) {
      this.errorHandler(error, "Something went wrong during access token generation");
      throw error;
    }
  }
  addBasicIframeStyles(iframe) {
    iframe.style.border = "0";
    iframe.style.height = "calc(100vh - 40px)";
    iframe.style.width = "100%";
  }
  loadEmbedID() {
    const experienceUrl = new URL(`https://embedid.trulioo.com/embedid/${this.publicKey}/at/${this.accessToken}`);
    const element = document.createElement("iframe");
    element.setAttribute("id", "embedid-module");
    element.setAttribute("allow", "camera");
    element.setAttribute("src", experienceUrl);
    const truliooEmbedIDContainer = document.getElementById("trulioo-embedid");
    truliooEmbedIDContainer.appendChild(element);
    const embedIDModule = document.getElementById("embedid-module");
    this.addBasicIframeStyles(embedIDModule);
  }
  errorHandler(error) {
    if (this.onInitialRenderComplete) {
      this.onInitialRenderComplete(error);
    }
    delete this.onInitialRenderComplete;
  }
}